var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66665 0.368408V1.6947H3.33265V0.368408H1.99965V1.6947H1.33265C1.1536 1.69912 0.977225 1.73695 0.813627 1.80603C0.650029 1.87511 0.502419 1.97408 0.379251 2.09728C0.256082 2.22048 0.159773 2.36548 0.0958369 2.52398C0.0319012 2.68249 0.00159466 2.85138 0.00665265 3.021L-0.000347319 12.3051C-0.00894147 12.6483 0.126604 12.9808 0.37653 13.2295C0.626455 13.4781 0.97033 13.6227 1.33265 13.6314H10.6657C11.0278 13.6219 11.3713 13.4772 11.6212 13.2287C11.8711 12.9802 12.0072 12.6482 11.9997 12.3051V3.021C12.0072 2.67802 11.8713 2.34613 11.6216 2.09768C11.3719 1.84923 11.0286 1.70438 10.6667 1.6947H9.99965V0.368408H8.66665ZM10.6667 12.3051H1.33265V5.01044H10.6657L10.6667 12.3051Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 7.66309H9.33276V10.9788H5.99976V7.66309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.3f26015b6195ba6b6b2126d95fcf42c4.svg";
export { ForwardRef as ReactComponent };